export const VERSION = '1.10.3';
